export const TaggingConstant= {
        flows:{
                aal:"New Service and Equipments",
                byod:"Bring Your Own Device",
                fwa:"Fixed Wirline Access"
        },
        page:{
                accountSelection:{pageName:"select account"},
                gridwall:{pageName:"device gridwall"},
                devicePdp:{pageName:"device details"},
                planSelection:{pageName:"select plan"},
                featureSelection:{pageName:"device insurance"},
                cart:{pageName:"device shopping cart",eventName:"scView"},
                checkout:{pageName:"review and submit",eventName:"scCheckout"},
                confirmation:{pageName:"confirm",eventName:"purchase"},
                accessoryGridwall:{pageName:"accessory gridwall"},
                accessoryPdp:{pageName:"accessory details"},
                byodDeviceValidation:{pageName:"device validation"},

        }
}